import { createAction } from 'src/lib/createAction';
import { HYDRATE } from 'next-redux-wrapper';
import { RootState } from 'src/state/reducer';

export const HYDRATE_ACTION = createAction(HYDRATE)<RootState>();
